module.exports = __webpack_public_path__ + "static/img/图层16.bfc71ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层16.png
// module id = 8Q/9
// module chunks = 0